import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@yme/atoms/input';
import { MobileDropdownSlider } from '@yme/atoms/mobile-dropdown-slider';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { INPUT_MAX_LENGTH } from '@yme/common/constants';
import { useWindowSize, EMAIL_KEY, getErrorState, getSimpleErrorMessage, useValidation, } from '@yme/common/hooks';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DefaultModalContentStyled, DefaultModalContentTextStyled } from '../styled';
import { BACK_IN_STOCK_MODAL_HEIGHT, CONFIGURATION_FORM } from './constants';
export function NotifyMeBackInStockModal({ labels, isRightToLeft, onSubmitAction, onHideModal, setFormData, isActive, setIsActive, }) {
    const [isNeedToCloseModal, setIsNeedToCloseModal] = useState(false);
    const inputRef = useRef(null);
    const { isInfiniteDesktopView } = useWindowSize();
    const { configure, isSubmitButtonDisabled, onFocus, onBlur, emailValue, onEmailChangeHandler } = useValidation({
        configurationArray: CONFIGURATION_FORM,
    });
    const { notifyMeBackInStockHeader, notifyMeButton, commonCancelButton, notifyMeStopKeepingEmailMessage, notifyMeEnterYourEmail, notifyMeInvalidEmailFormatError, commonEmailLabel, } = labels;
    const onSubmit = () => {
        setFormData({
            email: emailValue,
        });
        onSubmitAction();
        setIsNeedToCloseModal(true);
    };
    useEffect(() => {
        setFormData({
            email: emailValue,
        });
    }, [emailValue, setFormData]);
    const onFocusHandler = (key) => () => {
        if (key) {
            return onFocus(key);
        }
        return undefined;
    };
    const onBlurHandler = (value, key, isRequired) => () => {
        if (key) {
            return onBlur(value, key, isRequired);
        }
        return undefined;
    };
    const handleActive = (active) => {
        setIsActive(active);
    };
    const onFooterHide = isInfiniteDesktopView ? onHideModal : () => handleActive(false);
    const content = (React.createElement(DefaultModalContentStyled, null,
        React.createElement(DefaultModalContentTextStyled, null,
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, notifyMeStopKeepingEmailMessage)),
        React.createElement(Input, { id: "NotifyMeBackInStockEmailInput", name: "NotifyMeBackInStockEmailInput", label: commonEmailLabel, placeholder: notifyMeEnterYourEmail, changeHandler: onEmailChangeHandler, focusHandler: onFocusHandler(EMAIL_KEY), blurHandler: onBlurHandler(emailValue, EMAIL_KEY, configure[0]?.required), value: emailValue, type: "email", state: getErrorState(configure[0]), infoText: getSimpleErrorMessage(configure[0], notifyMeInvalidEmailFormatError), isRightToLeft: isRightToLeft, maxLength: INPUT_MAX_LENGTH.email, ref: inputRef, isRequired: true, isFocused: true })));
    const footer = (React.createElement(ModalWindowFooter, { isCancelButton: true, isSubmitButton: true, isFooterColumn: false, cancelButtonLabel: commonCancelButton, onHide: onFooterHide, onSubmit: onSubmit, submitButtonLabel: notifyMeButton, isSubmitButtonDisabled: isSubmitButtonDisabled, isBtnsWidthStyleReset: false, isPreventedSubmit: isNeedToCloseModal }));
    return isInfiniteDesktopView ? (React.createElement(StaticModalWindow, { onHide: onHideModal, staticModalSize: MD_MODAL, title: notifyMeBackInStockHeader, isRightToLeft: isRightToLeft, minHeight: BACK_IN_STOCK_MODAL_HEIGHT, footerComponent: footer }, content)) : (React.createElement(MobileDropdownSlider, { isActive: isActive, handleActiveMobileSlider: handleActive, title: notifyMeBackInStockHeader, isRightToLeft: isRightToLeft, footerComponent: footer }, content));
}
